import { createI18n } from 'vue-i18n'

const messages = {
  fr: {
    // Navbar
    nav: {
      home: 'Accueil',
      features: 'Fonctionnalités',
      pricing: 'Tarifs',
      howItWorks: 'Comment ça marche',
      testimonials: 'Témoignages',
      contact: 'Contact',
      demo: 'Demander une démo'
    },
    // Hero Section
    hero: {
      title: 'La solution digitale pour',
      titleHighlight: 'votre pressing.',
      description: 'Gérez vos commandes, fidélisez vos clients et développez votre activité avec notre suite d\'applications conçue spécialement pour les pressings modernes.',
      startTrial: 'Commencer l\'essai gratuit',
      watchDemo: 'Voir la démo',
      activePressings: 'Pressings actifs',
      ordersManaged: 'Commandes gérées',
      satisfaction: 'Satisfaction'
    },
    // Features Section
    features: {
      title: 'Nos Applications',
      subtitle: 'Une suite complète d\'outils pour digitaliser et optimiser la gestion de votre pressing.',
      managementApp: {
        title: 'Application de Gestion',
        description: 'Gérez vos commandes, clients, stocks et finances depuis une interface intuitive. Statistiques détaillées, rapports et suivi en temps réel.'
      },
      clientApp: {
        title: 'Application Client',
        description: 'Vos clients peuvent passer commande, suivre leur linge et payer directement depuis leur téléphone. Notifications automatiques incluses.'
      },
      deliveryApp: {
        title: 'Application Livreur',
        description: 'Optimisez vos livraisons avec le suivi GPS, la gestion des tournées et les confirmations de livraison en temps réel.'
      },
      integrations: {
        title: 'Intégrations',
        description: 'Mobile Money (Orange, MTN), impression de reçus, export comptable et bien plus. Tout ce dont votre pressing a besoin.'
      }
    },
    // How It Works Section - Client App
    howItWorksClient: {
      title: 'Comment ça marche',
      subtitle: 'Vos clients commandent en 4 étapes simples depuis leur téléphone.',
      steps: {
        choose: {
          title: 'Choisir le pressing',
          description: 'Le client trouve votre pressing et consulte vos services et tarifs.'
        },
        prepare: {
          title: 'Préparer la commande',
          description: 'Il sélectionne les articles à nettoyer et choisit la date de ramassage.'
        },
        pay: {
          title: 'Payer en ligne',
          description: 'Paiement sécurisé par Mobile Money (Orange, MTN) ou à la livraison.'
        },
        receive: {
          title: 'Suivre sa commande',
          description: 'Suivez en temps réel le statut de votre linge : collecte, nettoyage et livraison à domicile.'
        }
      }
    },
    // How It Works Section - Admin App
    howItWorksAdmin: {
      title: 'Gérez votre pressing facilement',
      subtitle: 'Une interface intuitive pour piloter toute votre activité.',
      steps: {
        dashboard: {
          title: 'Tableau de bord',
          description: 'Vue d\'ensemble de vos commandes, revenus et statistiques du jour.'
        },
        orders: {
          title: 'Gestion des commandes',
          description: 'Recevez, traitez et suivez chaque commande de A à Z.'
        },
        customers: {
          title: 'Fichier clients',
          description: 'Historique complet, préférences et fidélisation de vos clients.'
        },
        stats: {
          title: 'Statistiques',
          description: 'Analysez vos performances et prenez les bonnes décisions.'
        }
      }
    },
    // Delivery App Section
    deliveryApp: {
      title: 'Application Livreur',
      comingSoon: 'Bientôt disponible',
      subtitle: 'Optimisez vos livraisons avec notre application dédiée aux livreurs. Incluse dans l\'offre Premium.',
      features: {
        routes: 'Gestion des tournées',
        gps: 'Suivi GPS en temps réel',
        notifications: 'Notifications instantanées'
      },
      notify: 'Me notifier au lancement',
      placeholder: 'Entrez votre numéro (+237...)',
      successMessage: 'Merci ! Nous vous contacterons bientôt.'
    },
    // App Showcase Section
    appShowcase: {
      title: 'Une application pour chaque besoin',
      subtitle: 'Découvrez comment Kline transforme l\'expérience de vos clients et simplifie votre quotidien.',
      management: {
        title: 'Pour vous, le gérant',
        features: ['Tableau de bord en temps réel', 'Gestion des commandes', 'Suivi des paiements', 'Statistiques détaillées', 'Gestion des clients']
      },
      client: {
        title: 'Pour vos clients',
        features: ['Commande en ligne', 'Suivi du linge', 'Paiement Mobile Money', 'Historique des commandes', 'Notifications push']
      },
      appStore: 'Télécharger sur',
      playStore: 'Télécharger sur'
    },
    // Benefits Section
    benefits: {
      title: 'Pourquoi choisir Kline ?',
      subtitle: 'Rejoignez les pressings qui ont déjà fait le choix de la digitalisation.',
      items: {
        time: {
          title: 'Gagnez du temps',
          description: 'Automatisez les tâches répétitives et concentrez-vous sur votre cœur de métier.'
        },
        customers: {
          title: 'Fidélisez vos clients',
          description: 'Offrez une expérience moderne qui fait revenir vos clients.'
        },
        revenue: {
          title: 'Augmentez vos revenus',
          description: 'Nos pressings partenaires constatent +30% de commandes en moyenne.'
        },
        support: {
          title: 'Support dédié',
          description: 'Une équipe locale disponible pour vous accompagner au quotidien.'
        }
      }
    },
    // Testimonials Section
    testimonials: {
      title: 'Ils nous font confiance',
      subtitle: 'Découvrez les retours des gérants de pressing qui utilisent Kline',
      previous: 'Précédent',
      next: 'Suivant'
    },
    // Pricing Section
    pricing: {
      title: 'Tarifs simples et transparents',
      subtitle: 'Choisissez l\'offre adaptée à vos besoins. Sans engagement, annulez à tout moment.',
      perMonth: '/mois',
      mostPopular: 'Plus populaire',
      basic: {
        title: 'Basic',
        price: '1 000 XAF',
        description: 'Idéal pour démarrer la digitalisation de votre pressing',
        features: [
          'Application de gestion complète',
          'Gestion illimitée des commandes',
          'Gestion des clients',
          'Statistiques de base',
          'Support par WhatsApp'
        ],
        cta: 'Commencer gratuitement'
      },
      boost: {
        title: 'Boost',
        price: '1 500 XAF',
        description: 'Pour les pressings qui veulent fidéliser leurs clients',
        features: [
          'Tout de l\'offre Basic',
          'Application client personnalisée',
          'Notifications push automatiques',
          'Paiement Mobile Money',
          'Statistiques avancées',
          'Support prioritaire'
        ],
        cta: 'Essai gratuit 14 jours'
      },
      premium: {
        title: 'Premium',
        price: '2 500 XAF',
        description: 'La solution complète avec livraison intégrée',
        features: [
          'Tout de l\'offre Boost',
          'Application livreur',
          'Gestion des tournées',
          'Suivi GPS en temps réel',
          'Multi-établissements',
          'API & intégrations',
          'Account manager dédié'
        ],
        cta: 'Contacter l\'équipe'
      }
    },
    // CTA Section
    cta: {
      title: 'Prêt à digitaliser',
      titleHighlight: 'votre pressing ?',
      subtitle: 'Rejoignez les pressings modernes qui utilisent Kline pour gérer leur activité. Essai gratuit, sans engagement.',
      button: 'Démarrer mon essai gratuit',
      features: {
        freeSetup: 'Configuration gratuite',
        noCommitment: 'Sans engagement',
        cancelAnytime: 'Annulez à tout moment'
      }
    },
    // Footer
    footer: {
      about: {
        title: 'À propos de Kline',
        description: 'Kline est la solution SaaS de référence pour les pressings en Afrique. Nous aidons les professionnels du pressing à digitaliser leur activité et à offrir une meilleure expérience à leurs clients.'
      },
      quickLinks: {
        title: 'Liens rapides'
      },
      connect: {
        title: 'Nous contacter'
      },
      copyright: '© 2025 Kline. Tous droits réservés.'
    },
    dialog: {
      comingSoon: {
        title: 'Bientôt disponible',
        message: 'L\'application sera bientôt disponible sur les stores. Restez connecté !',
        close: 'Compris'
      }
    }
  },
  en: {
    // Navbar
    nav: {
      home: 'Home',
      features: 'Features',
      pricing: 'Pricing',
      howItWorks: 'How It Works',
      testimonials: 'Testimonials',
      contact: 'Contact',
      demo: 'Request a Demo'
    },
    // Hero Section
    hero: {
      title: 'The digital solution for',
      titleHighlight: 'your dry cleaning business.',
      description: 'Manage your orders, retain your customers and grow your business with our suite of applications designed specifically for modern dry cleaners.',
      startTrial: 'Start free trial',
      watchDemo: 'Watch demo',
      activePressings: 'Active businesses',
      ordersManaged: 'Orders managed',
      satisfaction: 'Satisfaction'
    },
    // Features Section
    features: {
      title: 'Our Applications',
      subtitle: 'A complete suite of tools to digitize and optimize your dry cleaning business management.',
      managementApp: {
        title: 'Management App',
        description: 'Manage your orders, customers, inventory and finances from an intuitive interface. Detailed statistics, reports and real-time tracking.'
      },
      clientApp: {
        title: 'Customer App',
        description: 'Your customers can place orders, track their laundry and pay directly from their phone. Automatic notifications included.'
      },
      deliveryApp: {
        title: 'Delivery App',
        description: 'Optimize your deliveries with GPS tracking, route management and real-time delivery confirmations.'
      },
      integrations: {
        title: 'Integrations',
        description: 'Mobile Money (Orange, MTN), receipt printing, accounting export and more. Everything your business needs.'
      }
    },
    // How It Works Section - Client App
    howItWorksClient: {
      title: 'How It Works',
      subtitle: 'Your customers order in 4 simple steps from their phone.',
      steps: {
        choose: {
          title: 'Choose the dry cleaner',
          description: 'The customer finds your business and checks your services and prices.'
        },
        prepare: {
          title: 'Prepare the order',
          description: 'They select the items to clean and choose the pickup date.'
        },
        pay: {
          title: 'Pay online',
          description: 'Secure payment via Mobile Money (Orange, MTN) or cash on delivery.'
        },
        receive: {
          title: 'Track your order',
          description: 'Track your laundry status in real-time: pickup, cleaning and home delivery.'
        }
      }
    },
    // How It Works Section - Admin App
    howItWorksAdmin: {
      title: 'Manage your business easily',
      subtitle: 'An intuitive interface to run your entire operation.',
      steps: {
        dashboard: {
          title: 'Dashboard',
          description: 'Overview of your orders, revenue and daily statistics.'
        },
        orders: {
          title: 'Order management',
          description: 'Receive, process and track each order from A to Z.'
        },
        customers: {
          title: 'Customer database',
          description: 'Complete history, preferences and customer loyalty.'
        },
        stats: {
          title: 'Statistics',
          description: 'Analyze your performance and make the right decisions.'
        }
      }
    },
    // Delivery App Section
    deliveryApp: {
      title: 'Delivery App',
      comingSoon: 'Coming Soon',
      subtitle: 'Optimize your deliveries with our dedicated driver app. Included in the Premium plan.',
      features: {
        routes: 'Route management',
        gps: 'Real-time GPS tracking',
        notifications: 'Instant notifications'
      },
      notify: 'Notify me at launch',
      placeholder: 'Enter your number (+237...)',
      successMessage: 'Thank you! We will contact you soon.'
    },
    // App Showcase Section
    appShowcase: {
      title: 'An app for every need',
      subtitle: 'Discover how Kline transforms your customers\' experience and simplifies your daily operations.',
      management: {
        title: 'For you, the manager',
        features: ['Real-time dashboard', 'Order management', 'Payment tracking', 'Detailed statistics', 'Customer management']
      },
      client: {
        title: 'For your customers',
        features: ['Online ordering', 'Laundry tracking', 'Mobile Money payment', 'Order history', 'Push notifications']
      },
      appStore: 'Download on',
      playStore: 'Download on'
    },
    // Benefits Section
    benefits: {
      title: 'Why choose Kline?',
      subtitle: 'Join the dry cleaners who have already chosen digitalization.',
      items: {
        time: {
          title: 'Save time',
          description: 'Automate repetitive tasks and focus on your core business.'
        },
        customers: {
          title: 'Retain your customers',
          description: 'Offer a modern experience that keeps your customers coming back.'
        },
        revenue: {
          title: 'Increase your revenue',
          description: 'Our partner businesses see +30% more orders on average.'
        },
        support: {
          title: 'Dedicated support',
          description: 'A local team available to support you every day.'
        }
      }
    },
    // Testimonials Section
    testimonials: {
      title: 'They trust us',
      subtitle: 'Discover feedback from dry cleaning managers who use Kline',
      previous: 'Previous',
      next: 'Next'
    },
    // Pricing Section
    pricing: {
      title: 'Simple and transparent pricing',
      subtitle: 'Choose the plan that fits your needs. No commitment, cancel anytime.',
      perMonth: '/month',
      mostPopular: 'Most Popular',
      basic: {
        title: 'Basic',
        price: '1,000 XAF',
        description: 'Ideal to start digitizing your dry cleaning business',
        features: [
          'Complete management app',
          'Unlimited order management',
          'Customer management',
          'Basic statistics',
          'WhatsApp support'
        ],
        cta: 'Start for free'
      },
      boost: {
        title: 'Boost',
        price: '1,500 XAF',
        description: 'For dry cleaners who want to retain their customers',
        features: [
          'Everything in Basic',
          'Customized customer app',
          'Automatic push notifications',
          'Mobile Money payment',
          'Advanced statistics',
          'Priority support'
        ],
        cta: '14-day free trial'
      },
      premium: {
        title: 'Premium',
        price: '2,500 XAF',
        description: 'The complete solution with integrated delivery',
        features: [
          'Everything in Boost',
          'Delivery app',
          'Route management',
          'Real-time GPS tracking',
          'Multi-location support',
          'API & integrations',
          'Dedicated account manager'
        ],
        cta: 'Contact sales'
      }
    },
    // CTA Section
    cta: {
      title: 'Ready to digitize',
      titleHighlight: 'your dry cleaning business?',
      subtitle: 'Join the modern dry cleaners using Kline to manage their business. Free trial, no commitment.',
      button: 'Start my free trial',
      features: {
        freeSetup: 'Free setup',
        noCommitment: 'No commitment',
        cancelAnytime: 'Cancel anytime'
      }
    },
    // Footer
    footer: {
      about: {
        title: 'About Kline',
        description: 'Kline is the leading SaaS solution for dry cleaners in Africa. We help dry cleaning professionals digitize their business and offer a better experience to their customers.'
      },
      quickLinks: {
        title: 'Quick Links'
      },
      connect: {
        title: 'Contact Us'
      },
      copyright: '© 2025 Kline. All rights reserved.'
    },
    dialog: {
      comingSoon: {
        title: 'Coming Soon',
        message: 'The app will be available on stores soon. Stay tuned!',
        close: 'Got it'
      }
    }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('kline-locale') || 'fr',
  fallbackLocale: 'en',
  messages
})

export default i18n